const namespace = 'nearpeer';
const createKey = (...segments) => [namespace, ...segments].join(':');

const keys = Object.freeze({
    persistentVersion: createKey('persistence', 'local-version'),
    sessionVersion: createKey('persistence', 'session-version'),
    app: Object.freeze({
        bootstrap: createKey('app', 'bootstrap'),
        roleGroupFilter: createKey('app', 'role-group-filter'),
        debug: createKey('app', 'debug'),
        discoverSortType: createKey('app', 'discover', 'sort-type'),
        discoverSearchFilter: createKey('app', 'discover', 'search-filter'),
        groupsContextFilter: createKey('app', 'groups', 'context-filter'),
        collapseHeadersDms: createKey('app', 'chat', 'collapse-headers', 'dms'),
        collapseHeadersGroups: createKey('app', 'chat', 'collapse-headers', 'groups')
    }),
    analytics: Object.freeze({
        gaClientId: createKey('analytics', 'ga-client-id')
    }),
    cordova: Object.freeze({
        currentFirebaseToken: createKey('cordova', 'firebase-token', 'current'),
        backgroundFirebaseToken: createKey('cordova', 'firebase-token', 'background'),
        lastHandledOpenUrl: createKey('cordova', 'last-handled-open-url'),
        lastHandledOpenUrlAt: createKey('cordova', 'last-handled-open-url-at')
    }),
    debug: Object.freeze({
        formEnabled: createKey('debug', 'forms', 'enabled'),
        navigation: createKey('debug', 'navigation'),
        clientSession: createKey('client-debug', 'session')
    }),
    e2e: Object.freeze({
        mockCommunication: createKey('e2e', 'mock', 'communication'),
        mockTwilio: createKey('e2e', 'mock', 'twilio'),
        mockSsoProvider: createKey('e2e', 'mock', 'sso-provider'),
        twilioIdentity: createKey('e2e', 'twilio', 'identity'),
        twilioPollMs: createKey('e2e', 'twilio', 'poll-ms')
    })
});

const migrations = Object.freeze([
    Object.freeze({
        version: 1,
        persist: Object.freeze({
            'role-group-filter': keys.app.roleGroupFilter,
            debug: keys.app.debug,
            'collapse-headers-dms': keys.app.collapseHeadersDms,
            'collapse-headers-groups': keys.app.collapseHeadersGroups,
            nearpeer_location_debug: keys.debug.navigation,
            FORM_DEBUG: keys.debug.formEnabled,
            'ga:clientId': keys.analytics.gaClientId,
            currentRegistrationIdFirebase: keys.cordova.currentFirebaseToken,
            newRegistrationId: keys.cordova.backgroundFirebaseToken,
            nearpeer_last_handled_open_url: keys.cordova.lastHandledOpenUrl,
            nearpeer_last_handled_open_url_at: keys.cordova.lastHandledOpenUrlAt,
            E2E_MOCK_COMMUNICATION: keys.e2e.mockCommunication,
            E2E_MOCK_TWILIO: keys.e2e.mockTwilio,
            E2E_PROVIDER_MOCK_SSO: keys.e2e.mockSsoProvider,
            E2E_TWILIO_IDENTITY: keys.e2e.twilioIdentity,
            E2E_TWILIO_POLL_MS: keys.e2e.twilioPollMs
        }),
        removePersist: Object.freeze([
            'nearpeer:persistence:version',
            'pushNotifPermissionLastAsked',
            'E2E_MOCK_SSO',
            'twilioEndpoint'
        ]),
        session: Object.freeze({
            'discover-sort-type': keys.app.discoverSortType,
            'discover-search-filter': keys.app.discoverSearchFilter,
            'mygroups-context-filter': keys.app.groupsContextFilter
        })
    })
]);

module.exports = Object.freeze({
    namespace,
    createKey,
    currentVersion: 1,
    keys,
    migrations
});
